export default "__VITE_ASSET__D1Gc9j3X__"